import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Toaster } from "./ui/sonner";

export const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-navy" data-testid="site-layout">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
    <Toaster position="top-right" richColors theme="dark" />
  </div>
);

export default Layout;
